export enum httpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH"
}  
     
export type IPRecord = {
    count: number
    lastReset: number
}

export interface UTMParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  device?: string;
  fbclid?: string;
  gclid?: string;
  landing_referrer?: string;
  // Click-to-WhatsApp: these are NOT URL params. They are set by the
  // ctwa-bridge (pal-agent side), which resolves the ad click id (ctwa_clid)
  // to real campaign/ad/source names. See resolveLeadAttribution in
  // lib/attribution.ts for why CTWA leads can never use URL macros.
  ctwa_clid?: string;
  ctwa_campaign?: string;
  ctwa_ad?: string;
  ctwa_source?: string;
}